import { render, staticRenderFns } from "./ViewInvoices.vue?vue&type=template&id=52e72815&scoped=true&"
import script from "./ViewInvoices.vue?vue&type=script&lang=js&"
export * from "./ViewInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e72815",
  null
  
)

export default component.exports